import { create } from "zustand";
import useAuthStore from "./use-auth-store";

interface CreditsStore {
  credits: number;
  setCredits: (credits: number) => void;
  deductCredits: (amount: number) => boolean;
  addCredits: (amount: number) => void;
  loadCredits: () => Promise<void>;
}

const INITIAL_CREDITS = 0;

const useCreditsStore = create<CreditsStore>()((set, get) => ({
  // Başlangıçta 0; kullanıcı girişinde useAuthStore.setUser içinde senkronlanır
  credits: INITIAL_CREDITS,

  // Kullanıcı girişinde veya sayfa yenilemede, auth.user.token'dan RAM'e yükle
  loadCredits: async () => {
    const user = useAuthStore.getState().user;
    if (!user) {
      set({ credits: INITIAL_CREDITS });
      return;
    }
    const creditFromUser =
      typeof user.token === "number" ? user.token : INITIAL_CREDITS;
    set({ credits: creditFromUser });
  },

  // RAM'de güncelle
  setCredits: (credits: number) => {
    set({ credits });
  },

  // Yeterli bakiye varsa düş, state'i güncelle
  deductCredits: (amount: number) => {
    const currentCredits = get().credits;
    if (currentCredits >= amount) {
      set({ credits: currentCredits - amount });
      return true;
    }
    return false;
  },

  // RAM'de arttır
  addCredits: (amount: number) => {
    const currentCredits = get().credits;
    set({ credits: currentCredits + amount });
  },
}));

export default useCreditsStore;
